module.exports = __webpack_public_path__ + "img/organ-security.fadb386.svg";